
import axios2 from '../../../../api/axios';
import React, {useState,useEffect} from 'react'
import {EyeFill,PencilFill,Trash3Fill,PersonPlus,SlashCircle} from "react-bootstrap-icons"
import { useNavigate,useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import loadingIcon from '../../../../Images/loading.gif'
import { getCookie, isEmpty, session_callback } from '../../../../Utilities/Utils';
import User_session from '../../../../Utilities/use_session';
import { getsession } from '../../../../actions/user.action';
import { useAuth } from '../../../../ContextApp/AuthContext';
import './enseignantcss.css'

function Enseignant() {
    const {user}=useAuth()
    const [enseignants,setEnseignant]=useState([])
    const [my_classe,setMy_classe]=useState("")
    const [curentpage,setCurentpage]=useState(1)
    const [search,setSearch]=useState('')
    const [recordperpage,setRecordperpage]=useState(50)
    let navigate=useNavigate()
    const [classes,setClasses]=useState([])
    const [searchTerm, setSearchTerm] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    let action="";
    // À placer avec vos autres useState
    const [statutOnglet, setStatutOnglet] = useState('Actif'); 

    const lastIndex=curentpage * recordperpage
    const firstIndex=lastIndex - recordperpage
    const [loading,setLoading]=useState(false)
    const [loadingD,setLoadingD]=useState(false)
    const csrf=()=>axios2.get('sanctum/csrf-cookie')
    localStorage.setItem("lastpage","/enseignant")
    useEffect(
        ()=>{
        /*   if(session_callback){
            handle()
            dispatch(getsession(localStorage.getItem('email'),localStorage.getItem("id"),getCookie("gesco_inf")))*/
            enseignantRequest()
            handle_classe_request()

         //  }
        },[])
    const enseignantRequest=async ()=>{
        //await csrf()
        setLoading(true)
      
        await axios2.post('api/getenseignants',{idecole:user?.ecole?.id}).then(
            (res)=>{
                setEnseignant(res.data.items)
                setLoading(false)
                console.log(res)
            }
        ).catch((err)=>{
            console.log(err)
        })
    }
    const handleActivate=async(enseignant,action)=>{
        Swal.fire({
            title: action === "Désactivation" ? 'Désactivation d\'un enseignant' : 'Réactivation d\'un enseignant',
            text: action === "Désactivation" 
                ? 'Vous êtes sur le point de désactiver temporairement cet enseignant.' 
                : 'Vous êtes sur le point de réactiver cet enseignant.',
            icon:'warning',
            showDenyButton:true,
            showCancelButton:true,
            confirmButtonText:'Confirmer',
            denyButtonText:'Annuler'
        }).then(async(resultat)=>{
            if(resultat.isConfirmed){
                setLoadingD(true)   
                await axios2.post('api/enseignant/activate',{id:enseignant,idecole:user?.ecole?.id}).then((res)=>{
                    Swal.fire({
                        title: action === "Désactivation" ? 'Désactivation réussie' : 'Activation réussie',
                        text:res.data.message,
                        icon:'success'
                    })
                    enseignantRequest()
                    setLoadingD(false)
                }).catch((err)=>{
                    Swal.fire({
                        title: action === "Désactivation" ? 'Erreur de désactivation' : 'Erreur de réactivation',
                        text:err.response.data.error,
                        icon:'error'
                    })
                    setLoadingD(false)
                })
            }
        })
    }
    const handleDelete = async (idEnseignant) => {
            
            setMessage("");
            setError("");
    
            try {
                // Remplacez cette route par votre route API de suppression
                // Exemple : api/enseignants/delete ou api/eleves (avec type_transact)
                const res = await axios2.post(`api/enseignant/delete`, {
                    id: idEnseignant,
                    idecole: user?.ecole?.id
                });
    
                setMessage(res.data.message || "Enseignant supprimé avec succès.");
                
                // Rafraîchir la liste localement sans recharger la page
                setEnseignant(enseignants.filter(ens => ens.id !== idEnseignant));
                Swal.fire({
                    title: 'Suppression réussie',
                    text: res.data.message || "L'enseignant a été supprimé avec succès.",
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
            } catch (err) {
                console.error(err);
                setError(err.response?.data?.error || "Une erreur est survenue lors de la suppression.");
            } finally {
                setLoadingD(false);
            }
        };
    /*useEffect(()=>{
        const records= search.toLowerCase() === '' ? eleves.slice(firstIndex, lastIndex) : eleves.filter((eleve)=>{return search.toLowerCase() === '' ? eleve : eleve.nom_complet.toLowerCase().includes(search)}).slice(firstIndex, lastIndex)
        const recordNpage=search.toLowerCase() === '' ? eleves : eleves.filter((eleve)=>{ return eleve.nom_complet.toLowerCase().includes(search)})
        const npage=Math.ceil(recordNpage.length/recordperpage)
        const numbers=[...Array(npage+1).keys()].slice(1)   
            function affichage(){
                eleves.length>0 ? 
    
                        records.filter((eleve)=>{
                    return search.toLowerCase() === '' ? eleve : eleve.nom_complet.toLowerCase().includes(search)
                }).map((eleve,indexV)=>
                {
                  return(
                        <tr key={indexV} className='ligne'>
                            <td>{indexV+1}</td>
                            <td>{eleve.nom.toLowerCase() + ' '+ eleve.postnom.toLowerCase() + ' ' + eleve.prenom.toLowerCase()}</td>
                            <td>{eleve.sexe}</td>
                            <td>{eleve.adresse.toLowerCase()}</td>
                            <td>{eleve.date_naissance}</td>
                            <td>{eleve.lieu_naissance.toLowerCase()}</td>
                            <td>{eleve.numero_serni}</td>
                            <td><EyeFill color="lightgreen" size={20} className='d-inline-flex mx-2 icone'  /><PencilFill color="royalblue" size={20} className='d-inline-flex mx-2 icone' onClick={()=>navigate(`${eleve.id}`)}/>  <Trash3Fill color='brown' size={20} className='d-inline-flex mx-2 icone' onClick={()=>AlertNotification(eleve.id)} /> </td>
                        </tr>
                  )
                    
                })
               :
                <div className="">
                    Aucun élève n'a été trouvé
                </div>
            }
    },[eleves])*/
   
    const {id}=useParams()
   // const records= search === '' && my_classe==='' ? enseignants.slice(firstIndex, lastIndex) : enseignants.filter((enseignant)=>{return search === '' && my_classe==='' ? enseignant : !isEmpty(my_classe) ? enseignant.nom_complet.includes(search) && enseignant.idclasse==my_classe : enseignant.nom_complet.includes(search)}).slice(firstIndex, lastIndex)
    const records = enseignants
  .filter((enseignant) => {
    // 1. On ne garde QUE les enseignants actifs
    if (enseignant.etat !== statutOnglet) return false; 

    // 2. On applique les filtres de recherche et de classe
    if (search === '' && my_classe === '') {
      return true;
    } else if (my_classe !== '') {
      return enseignant.nom_complet.toLowerCase().includes(search.toLowerCase()) && enseignant.idclasse == my_classe;
    } else {
      return enseignant.nom_complet.toLowerCase().includes(search.toLowerCase());
    }
  })
  .slice(firstIndex, lastIndex);

  // const recordNpage=search === '' && my_classe==='' ? enseignants : enseignants.filter((enseignant)=>{ return enseignant.nom_complet.includes(search) && enseignant.idclasse==my_classe})
    //const npage=Math.ceil(recordNpage.length/recordperpage)
    //const numbers=[...Array(npage+1).keys()].slice(1)    
   //const recordperpage=2
    
   const recordNpage = enseignants.filter((enseignant) => { 
    if (enseignant.etat !== statutOnglet) return false;
    const matchSearch = search === '' || (enseignant.nom_complet && enseignant.nom_complet.toLowerCase().includes(search.toLowerCase()));
    const matchClasse = my_classe === '' || enseignant.idclasse == my_classe;
    return matchSearch && matchClasse;
});

const npage = Math.ceil(recordNpage.length / recordperpage) || 1;
const numbers = [...Array(npage + 1).keys()].slice(1);

    //const numbers=[1,2,3,4,5]
    
    const Iteration=()=>{
        return (loading) ? (
            <div className='w-100 mx-auto'>
                <img src={loadingIcon} alt='loading'/>
            </div>
        ) : (
            records.length > 0 &&
                records.filter((enseignant)=>{
                    return search === '' ? enseignant : enseignant.nom_complet.includes(search)
                }).map((enseignant,indexV)=>
                {
                     const nomComplet = `${enseignant.nom.toUpperCase()} ${enseignant.postnom} ${enseignant.prenom}`;

                  return(
                      /*  <tr key={indexV} className='ligne'>
                            <td>{indexV+1}</td>
                            <td>{enseignant.nom.toLowerCase() + ' '+ enseignant.postnom + ' ' + enseignant.prenom}</td>
                            <td>{enseignant.sexe}</td>
                            <td>{enseignant.adresse.toLowerCase()}</td>
                            <td>{enseignant.date_naissance}</td>
                            <td>{enseignant.lieu_naissance}</td>
                            <td>{enseignant.niveau}</td>
                            <td>{enseignant.domaine}</td>
                            <td>{enseignant.my_classe}</td>
                            <td><EyeFill color="lightgreen" size={20} className='d-inline-flex mx-2 icone'  /><PencilFill color="royalblue" size={20} className='d-inline-flex mx-2 icone' onClick={()=>navigate(`${enseignant.id}`)}/>  <Trash3Fill color='brown' size={20} className='d-inline-flex mx-2 icone' onClick={()=>AlertNotification(enseignant.id)} /> </td>
                        </tr>*/
                        // Dans votre fonction Iteration(), retournez ce format :
<tr className="hover-bg-light transition-all">
    <td className="ps-4 fw-bold text-muted">{indexV + 1}</td>
    <td>
        <div className="d-flex align-items-center">
            <div className="avatar-sm bg-info bg-opacity-10 text-info rounded-circle me-3 d-flex align-items-center justify-content-center fw-bold">
                {enseignant.nom_complet.charAt(0)}
            </div>
            <div>
                <div className="fw-bold text-dark">{enseignant.nom_complet}</div>
                <small className="text-muted">{enseignant.sexe === 'M' ? 'Homme' : 'Femme'}</small>
            </div>
        </div>
    </td>
    <td>
        <div className="fw-semibold text-dark">{enseignant.domaine}</div>
        <div className="badge bg-light text-secondary border fw-normal">{enseignant.niveau}</div>
    </td>
    <td>
        <small className="d-block fw-bold text-muted">{enseignant.date_naissance}</small>
        <small className="text-lowercase">{enseignant.lieu_naissance}</small>
    </td>
    <td>
        {enseignant.titulaire === "Oui" ? 
            <span className="badge bg-success-subtle text-success px-2 py-1 rounded-pill">Titulaire</span> : 
            <span className="badge bg-light text-muted px-2 py-1 rounded-pill">Remplaçant</span>
        }
    </td>
    <td className="text-end pe-4 align-middle">
        {
            enseignant.etat === "Actif" ?
       
    <div className="d-flex justify-content-end gap-2">
        
        {/* BOUTON VOIR */}
        <button 
            className="btn btn-sm btn-light border-0 rounded-3 p-2 transition-all hover-scale" 
            title="Désactiver temporairement l'enseignant"
            onClick={() => handleActivate(enseignant.id,action="Désactivation")}
        >
            <SlashCircle  color="#198754" size={18} className="d-block" />
        </button>

        {/* BOUTON MODIFIER */}
        <button 
            className="btn btn-sm btn-light border-0 rounded-3 p-2 transition-all hover-scale" 
            title="Modifier les informations de l'enseignant"
            onClick={() => navigate(`${enseignant.id}`)}
        >
            <PencilFill color="#0d6efd" size={18} className="d-block" />
        </button>

        {/* BOUTON SUPPRIMER */}
        <button 
            className="btn btn-sm btn-light border-0 rounded-3 p-2 transition-all hover-scale-danger" 
            title="Supprimer définitivement l'enseignant"
            
            onClick={() => AlertNotification(enseignant.id, nomComplet)}
        >
            <Trash3Fill color="#dc3545" size={18} className="d-block" />
            
        </button>
    </div>
    :
    <button className="btn btn-md btn-danger border-0 rounded-3 p-2 transition-all hover-scale-danger" title="Activer l'enseignant" onClick={() => handleActivate(enseignant.id,action="Réactivation")}>
        Réactiver
    </button>
     }
</td>

</tr>

                  )                    
                }
                )
            
        )
        
            }   
            function AlertNotification(ideleve,nomcomplet){
                Swal.fire({
                    title:'Suppression d\'un enseignant',
                    text:`Vous êtes sur le point de supprimer l'enseignant ${nomcomplet}.`,
                    icon:'warning',
                    showDenyButton:true,
                    showCancelButton:true,
                    confirmButtonText:'Confirmer',
                    denyButtonText:'Annuler'
                }).then((resultat)=>{
                    if(resultat.isConfirmed){
                        handleDelete(ideleve)
                            }
                })
            }
            const handle_classe_request=async()=>{
                try{
                    await axios2.post('api/classes_getter',{idecole:user?.ecole?.id}).then((res)=>{
        
                        setClasses(res.data.items)
                    })
                }
                catch(e){
        
                }
            }
    return(

        <>
       
 <div className="container-fluid py-4 bg-light min-vh-100 px-lg-5">
    
    {/* HEADER : Accueil & Stats Rapides */}
    <div className="row align-items-center mb-4 g-3">
        <div className="col-md-6 text-start">
            <h2 className="fw-extrabold text-dark mb-1">👨‍🏫 Gestion des Enseignants</h2>
            <p className="text-muted mb-0">Bienvenue, <span className="text-primary fw-bold">Mr. [Nom]</span> — Voici l'état actuel de votre effectif.</p>
        </div>
        <div className="col-md-6 d-flex justify-content-md-end gap-2">
            <div className="bg-white p-2 px-3 rounded-4 shadow-sm border-0 d-flex align-items-center">
                <div className="bg-primary bg-opacity-10 text-primary p-2 rounded-3 me-3">
                    <i className="bi bi-people-fill fs-4"></i>
                </div>
                <div>
                    <small className="text-muted d-block text-uppercase fw-bold" style={{fontSize: '0.7rem'}}>Total Membres</small>
                    <span className="h5 fw-bold mb-0">{records.length}</span>
                </div>
            </div>
            <button onClick={()=>navigate('insertion')} className='btn btn-primary btn-lg rounded-4 shadow-sm d-flex align-items-center px-4'>
                <PersonPlus color='white' size={20} className='me-2' /> 
                <span className="fw-bold fs-6">Nouveau</span>
            </button>
        </div>
    </div>
        <ul className="nav nav-pills mb-3 gap-2 px-4" id="pills-tab" role="tablist">
    <li className="nav-item" role="presentation">
        <button 
            className={`nav-link rounded-pill px-4 shadow-sm ${statutOnglet === 'Actif' ? 'active' : ''}`} 
            type="button"
            onClick={() => { setStatutOnglet('Actif'); setCurentpage(1); }}
        >
            Enseignants Actifs ({enseignants.filter(e => e.etat === "Actif").length})
        </button>
    </li>
    <li className="nav-item" role="presentation">
        <button 
            className={`nav-link rounded-pill px-4 shadow-sm ${statutOnglet === 'Inactif' ? 'active bg-danger text-white' : ''}`} 
            type="button"
            onClick={() => { setStatutOnglet('Inactif'); setCurentpage(1); }}
        >
            Désactivés ({enseignants.filter(e => e.etat === "Inactif").length})
        </button>
    </li>
</ul>

    {/* BARRE D'ACTIONS : Recherche & Filtres */}
    <div className="card border-0 shadow-sm rounded-4 mb-4">
        <div className="card-body p-3">
            <div className="row g-3 align-items-center">
                <div className="col-md-5">
                    <div className="input-group input-group-lg">
                        <span className="input-group-text bg-light border-0"><i className="bi bi-search text-muted"></i></span>
                        <input type="text" placeholder='Rechercher par nom ou domaine...' className='form-control bg-light border-0 fs-6 shadow-none' 
                               onChange={(e)=>setSearch(e.target.value.toLowerCase())} value={search} />
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="d-flex align-items-center bg-light rounded-3 px-3 py-1">
                        <i className="bi bi-filter text-primary me-2"></i>
                        <select className='form-select bg-transparent border-0 shadow-none fw-semibold' onChange={(e)=>setMy_classe(e.target.value)}>
                            <option value="">Filtrer par Classe (Toutes)</option>
                            {classes.map((cla)=>(<option value={cla.id} key={cla.id}>{cla.nom}</option>))}
                        </select>
                    </div>
                </div>
                <div className="col-md-3">
                     <div className="d-flex align-items-center bg-light rounded-3 px-3 py-1">
                        <i className="bi bi-list-ol text-muted me-2"></i>
                        <input type="number" className='form-control bg-transparent border-0 shadow-none' 
                               placeholder='Lignes/Page' value={recordperpage} onChange={(e)=>setRecordperpage(e.target.value)} />
                     </div>
                </div>
            </div>
        </div>
    </div>

    {/* TABLE DE DONNÉES : Look Modernisé */}
    <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
                <thead className="bg-light border-bottom">
                    <tr className="text-secondary text-uppercase small fw-bold">
                        <th className="ps-4 py-3">#</th>
                        <th>Identité</th>
                        <th>Spécialité</th>
                        <th>Infos Naissance</th>
                        <th>Statut</th>
                        <th className="text-end pe-4">Actions</th>
                    </tr>
                </thead>
                <tbody className="border-top-0">
                    {Iteration()}
                </tbody>
            </table>
        </div>

        {/* PAGINATION MODERNE */}
        <div className="card-footer bg-white border-0 py-3 px-4 d-flex justify-content-between align-items-center">
            <small className="text-muted fw-semibold">Page {curentpage} sur {numbers.length}</small>
            <nav>
                <ul className='pagination pagination-sm mb-0 gap-1'>
                    <li className={`page-item ${curentpage === 1 ? 'disabled' : ''}`}>
                        <button className='page-link rounded-circle border-0 shadow-none' onClick={Prepage}><i className="bi bi-chevron-left"></i></button>
                    </li>
                    {numbers.map((number,index)=> (
                        <li className={`page-item ${curentpage === number ? 'active': '' }`} key={index}>
                            <button className='page-link rounded-circle border-0 fw-bold mx-1 shadow-sm' onClick={()=>changeCPage(number)}>{number}</button>
                        </li>
                    ))}
                    <li className={`page-item ${curentpage === numbers.length ? 'disabled' : ''}`}>
                        <button className='page-link rounded-circle border-0 shadow-none' onClick={Nextpage}><i className="bi bi-chevron-right"></i></button>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</div>

        </>
    )
function Prepage(){
    if(curentpage > 1){
        setCurentpage(curentpage-1)
    }
}
function changeCPage(id){
   setCurentpage(id)
}
function Nextpage(){
    if(curentpage < npage){
       // alert(curentpage)
        setCurentpage(curentpage+1)
    }
}

}
export default Enseignant;

